import { ProgressMediaResponseDTO } from '@models/api/ProgressMediaResponseDTO'
import { Download } from '@models/downloads/Download'
import { DownloadRequestParams } from '@models/downloads/DownloadRequestParams'
import { emitter } from '@services/emitter'
import { PersistentDataService } from '@services/PersistentDataService'
import { defineStore } from 'pinia'
import { Ref, ref, watch } from 'vue'

export const useDownloadsStore = defineStore('downloadsStore', () => {
  const downloads = ref<Download[]>([]) as Ref<Download[]>
  const isDownloadPanelOpen = ref(false)

  const historicDownloads = PersistentDataService.getOptions('downloadHistory')
  if (historicDownloads) {
    const persistentDownloads = historicDownloads.map((d) =>
      Download.fromDTO(d)
    )
    const recentDownloads = persistentDownloads.filter(
      (d) => d.creationDate && d.creationDate.diff(new Date(), 'hour') < 24
    )
    downloads.value = recentDownloads
  }

  watch(
    downloads.value,
    () => {
      PersistentDataService.saveOptions(
        'downloadHistory',
        downloads.value.map((d) => d.toDTO())
      )
    },
    { deep: true }
  )

  function createDownload(
    id: Download['id'],
    title: Download['title'],
    type: Download['type'],
    fileType: Download['fileType'],
    request?: DownloadRequestParams,
    shouldPrintWhenCompleted?: boolean
  ) {
    if (!isDownloadInList(id)) {
      const download = Download.createPending(
        id,
        title,
        type,
        fileType,
        request,
        shouldPrintWhenCompleted
      )
      downloads.value.push(download)
      emitter.emit('openDownloadDialog', true)
    }
  }

  function isDownloadInList(id: Download['id']) {
    return downloads.value.some((d) => d.id === id)
  }

  function updateDownloadStatus(newStatus: ProgressMediaResponseDTO) {
    const download = downloads.value.find((d) => d.id === newStatus.uuid)
    if (download) {
      download.progress =
        Number(newStatus.progress) && Math.round(Number(newStatus.progress))
      download.state = newStatus.status
      if (newStatus.status === 'complete') {
        download.downloadFile()
      }
    }
  }

  return {
    isDownloadPanelOpen,
    downloads,
    createDownload,
    updateDownloadStatus
  }
})
